// eslint-disable-next-line import/prefer-default-export
export enum TrackingEvent {
    AddToFavourites = 'AddToFavourites',
    AddToBasket = 'AddToBasket',
    ProductClick = 'ProductClick',
    ProductClickAndAddToBasket = 'ProductClickAndAddToBasket',
    ProductClickQuickSearch = 'ProductClickQuickSearch',
    SearchInitiated = 'SearchInitiated',
    Search = 'Search'
}
